module.exports = __webpack_public_path__ + "static/media/client_support_rounded_corners.8a435196.png";